import React from 'react';

import useLediumPage from '@client/hooks/useLediumPage';
import { usePageStore } from '@client/store/pageStore/context/pageContext';

import ZonesView from './ZonesView';

const Zones = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    const { mainMenu, onSave } = useLediumPage({
        saveDataMap: () => ({
            name: formData.name,
            description: formData.description,
            parent: formData.parent
        })
    });

    if (!formData.loaded) {
        return null;
    }

    return <ZonesView onClose={mainMenu} onSave={onSave} />;
};

export default Zones;
